module.exports = __webpack_public_path__ + "img/avatar-12.38299472.png";